// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mat-form-field {\r\n    width: 80%;\r\n}", "",{"version":3,"sources":["webpack://./src/app/projects/edit-sales-order/quality/quality.component.css"],"names":[],"mappings":"AAAA;IACI,UAAU;AACd","sourcesContent":[".mat-form-field {\r\n    width: 80%;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
